import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")!
  const _component_ion_segment = _resolveComponent("ion-segment")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_TeacherAchieveJUPASModal = _resolveComponent("TeacherAchieveJUPASModal")!
  const _component_AchieveJUPASResultPageModal = _resolveComponent("AchieveJUPASResultPageModal")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_grid, {
            class: "ion-no-padding",
            fixed: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, { style: {"--min-height":"32px"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_segment, {
                    modelValue: $setup.selectedView,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.selectedView) = $event)),
                    mode: "md",
                    scrollable: "",
                    color: "dark",
                    style: {"min-height":"24px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_segment_button, {
                        value: "teacher",
                        class: "no-text-transform short-segment-btn"
                      }, {
                        default: _withCtx(() => _cache[1] || (_cache[1] = [
                          _createTextVNode("Teacher view")
                        ])),
                        _: 1,
                        __: [1]
                      }),
                      _createVNode(_component_ion_segment_button, {
                        value: "student",
                        class: "no-text-transform short-segment-btn"
                      }, {
                        default: _withCtx(() => _cache[2] || (_cache[2] = [
                          _createTextVNode("Student view")
                        ])),
                        _: 1,
                        __: [2]
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_grid, {
            class: "ion-no-padding",
            fixed: ""
          }, {
            default: _withCtx(() => [
              ($setup.selectedView === 'teacher')
                ? (_openBlock(), _createBlock(_component_TeacherAchieveJUPASModal, {
                    key: 0,
                    isDemo: true
                  }))
                : (_openBlock(), _createBlock(_component_AchieveJUPASResultPageModal, {
                    key: 1,
                    isDemo: true
                  }))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}